import { render } from "./RenewalNoticePopup.vue?vue&type=template&id=663ccae2&scoped=true&ts=true"
import script from "./RenewalNoticePopup.vue?vue&type=script&lang=ts"
export * from "./RenewalNoticePopup.vue?vue&type=script&lang=ts"

import "./RenewalNoticePopup.vue?vue&type=style&index=0&id=663ccae2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663ccae2"]])

export default __exports__